/**
 * Admin Panel Component
 * Main admin panel that combines all admin features
 */

import { useState } from 'react';
import { AdminLayout } from './AdminLayout';
import { AdminDashboard } from './AdminDashboard';
import { AdminUsers } from './AdminUsers';
import { AdminSimulation } from './AdminSimulation';

type AdminTab = 'dashboard' | 'users' | 'simulation';

interface AdminPanelProps {
  onBack: () => void;
}

export function AdminPanel({ onBack }: AdminPanelProps) {
  const [activeTab, setActiveTab] = useState<AdminTab>('dashboard');

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <AdminDashboard />;
      case 'users':
        return <AdminUsers />;
      case 'simulation':
        return <AdminSimulation />;
      default:
        return <AdminDashboard />;
    }
  };

  return (
    <AdminLayout
      onBack={onBack}
      activeTab={activeTab}
      onTabChange={setActiveTab}
    >
      {renderContent()}
    </AdminLayout>
  );
}
